import React, { useEffect } from 'react'
import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Link,NavLink, useNavigate } from 'react-router-dom';
import { FaTruckMoving, FaPlusCircle, FaFile, FaCarSide } from "react-icons/fa";
import { AiFillCamera } from 'react-icons/ai';

export default  ({user,vehicle}) => {
  const [file, setfile] = useState(require("../assets/img/account-icon.png"));
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobileWidth = 576; // Define your mobile width threshold
      setIsMobile(window.innerWidth < mobileWidth);
    };

    handleResize(); // Initial check

    // Attach the resize event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const ProfileHandelChange = (e) =>{
     setfile(URL.createObjectURL(e.target.files[0]))
    }
    const [status, setstatus] = useState(false);
    const navigate=useNavigate();
  return (
    <div>
      <div className='ps-0 ps-md-3 '>
        <div className=""  style={{ backgroundColor: "#015A96", borderTopLeftRadius: 20,
      borderBottomLeftRadius:20 }}>
        { (status  ||(!isMobile))&& 
        <div className=" sidebar" style={{height:'95vh', overflow:'auto'}}>
          <div className="side-bar-content pt-5 d-flex flex-wrap flex-column align-items-center">
          <div className=' profile_img'>
            <div style={{width:'5rem'}} className=" img pb-2 border border-2 border-top-0 border-end-0 border-start-0 border-white">
              <img width="100%" src={file} alt="" className="rounded-circle mw-100" />
            </div>
            <input hidden type="file" name="" id="uplod-profile" onChange={ProfileHandelChange} />
            <label htmlFor="uplod-profile">
            <FaPlusCircle className='img_icon'/>
            </label>
            </div>
            <div className="sidebar-links">
              <ul className="list-unstyled sidebar_list p-2">
                <NavLink className='text-white nav-link' to={"/photograperaccount"}>
                <li className="m-2 p-2" onClick={()=>{
                  setstatus(false)
                  // navigate('/photograperaccount')
                  }}>
                  <i className="bi bi-person-fill " /> 
                  <span className="ps-2 ">
                  Account
                  </span>
                </li>
                  </NavLink>

                  <NavLink className='text-white nav-link' to={"/photographerrequest"}>
                <li className="m-2 mt-1 p-2" onClick={()=>{
                  setstatus(false)
                  // navigate('/photographerrequest')
                  }}>
                    <i className="bi bi-chat-left-fill" /> 
                    <span className="ps-2 ">
                    Requests
                    </span>
                </li>
                  </NavLink>

                  <NavLink className='text-white nav-link' to={"/photographer-schedule"}>
                <li className="m-2 mt-1 p-2" onClick={()=>{
                  setstatus(false)
                  // navigate('/photographer-schedule')
                  }}>
                  <i className="bi bi-calendar-fill" /> 
                  <span className="ps-2 ">
                  Schedule
                  </span>
                </li>
                  </NavLink>

                  <NavLink className='text-white nav-link' to={"/photographerjob"}>
                  <li className="m-2 mt-1 pt-2 px-1" 
                  onClick={()=>{
                  setstatus(false)
                  // navigate('/installerjob')
                  }}>
                  {/* <i className="bi bi-camera-fill" />  */}
                  {/* <img src={require("../../src/assets/img/schedule-job-icon.png")} alt="" /> */}
                  <AiFillCamera size={35}/>
                  {/* <i className="bi bi-paint" />  */}
                  
                  <span className="ps-2 ">
                  Jobs
                  </span>
                </li>
                  </NavLink>

                  <NavLink className='text-white nav-link' to={"/photographerpayment"}>
                <li className="m-2 mt-1 p-2" onClick={()=>{
                  setstatus(false)
                  // navigate('/photographerpayment')
                  }}>
                  <i className="bi bi-credit-card-fill" /> 
                  <span className="ps-2 ">
                  Payment
                  </span>
                  </li>
                  </NavLink>

                  <NavLink className='text-white nav-link' to={"/photographersetting"}>
               <li className="setting m-2 mt-1 p-2" onClick={()=>{
                  setstatus(false)
                  // navigate('/photographersetting')
                  }}>
                 <i className="bi bi-gear-fill" /> 
                  <span className="ps-2 ">Settings</span>
                </li> 
                  </NavLink>
                
              </ul>
            </div>
          </div> 
        </div>    
        }
        <button onClick={()=>setstatus(!status)} className="open-menu d-block d-sm-none ms-auto text-white fs-2 border-0 bg-blue rounded-pill p-3 position-absolute top-0 end-0"><i className="bi bi-list" /></button>
        </div> 
      </div>
    </div>
  )
}
